import { render, staticRenderFns } from "./declare-ticket-rule-ticket-status-chip.vue?vue&type=template&id=d39d9592&scoped=true&"
import script from "./declare-ticket-rule-ticket-status-chip.vue?vue&type=script&lang=js&"
export * from "./declare-ticket-rule-ticket-status-chip.vue?vue&type=script&lang=js&"
import style0 from "./declare-ticket-rule-ticket-status-chip.vue?vue&type=style&index=0&id=d39d9592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39d9592",
  null
  
)

export default component.exports